export default "__VITE_ASSET__CGxp2Nz1__"